var _rect, _rect2, _rect3, _text, _g, _g2, _g3, _g4, _path, _path2, _path3, _defs, _rect4, _text2, _text3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImageProcessingUtils(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 400 300",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "imageGrad",
    x1: "0%",
    y1: "0%",
    x2: "100%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    style: {
      stopColor: "#1a3d4d",
      stopOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    style: {
      stopColor: "#2d5f6f",
      stopOpacity: 1
    }
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 400,
    height: 300,
    fill: "url(#imageGrad)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 40,
    width: 280,
    height: 200,
    rx: 8,
    fill: "none",
    stroke: "#00ffff",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 50,
    width: 260,
    height: 30,
    fill: "#00ffff",
    opacity: 0.1,
    rx: 5
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 70,
    textAnchor: "middle",
    fontSize: 13,
    fill: "#00ffff",
    fontWeight: "bold"
  }, "image_processing_utils")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(100, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 4,
    fill: "none",
    stroke: "#00ff88",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 5,
    width: 35,
    height: 35,
    fill: "none",
    stroke: "#00ff88",
    strokeWidth: 1,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 22.5,
    y: 28,
    textAnchor: "middle",
    fontSize: 8,
    fill: "#00ff88",
    fontWeight: "bold"
  }, "RESIZE"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(160, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 4,
    fill: "none",
    stroke: "#ffd93d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 5 5 L 40 5 L 40 10 L 35 10 L 35 35 L 40 35 L 40 40 L 5 40 Z",
    fill: "none",
    stroke: "#ffd93d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("text", {
    x: 22.5,
    y: 28,
    textAnchor: "middle",
    fontSize: 8,
    fill: "#ffd93d",
    fontWeight: "bold"
  }, "CROP"))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(220, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 4,
    fill: "none",
    stroke: "#ff9d3d",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 15,
    fill: "none",
    stroke: "#ff9d3d",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 22.5,
    cy: 22.5,
    r: 10,
    fill: "none",
    stroke: "#ff9d3d",
    strokeWidth: 0.5,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 22.5,
    y: 28,
    textAnchor: "middle",
    fontSize: 8,
    fill: "#ff9d3d",
    fontWeight: "bold"
  }, "FILTER"))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(280, 100)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 45,
    height: 45,
    rx: 4,
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 22.5 5 Q 38 5 38 20 Q 38 35 22.5 35 Q 8 35 8 20",
    fill: "none",
    stroke: "#a78bfa",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "22.5,5 26,13 19,10",
    fill: "#a78bfa"
  }), /*#__PURE__*/React.createElement("text", {
    x: 22.5,
    y: 28,
    textAnchor: "middle",
    fontSize: 8,
    fill: "#a78bfa",
    fontWeight: "bold"
  }, "ROTATE"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 145 122 L 155 122",
    stroke: "#00ffff",
    strokeWidth: 1,
    markerEnd: "url(#arrow1)",
    opacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 205 122 L 215 122",
    stroke: "#00ffff",
    strokeWidth: 1,
    markerEnd: "url(#arrow1)",
    opacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 265 122 L 275 122",
    stroke: "#00ffff",
    strokeWidth: 1,
    markerEnd: "url(#arrow1)",
    opacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("marker", {
    id: "arrow1",
    markerWidth: 10,
    markerHeight: 10,
    refX: 9,
    refY: 3,
    orient: "auto"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 0, 10 3, 0 6",
    fill: "#00ffff",
    opacity: 0.5
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 70,
    y: 170,
    width: 260,
    height: 50,
    fill: "#00ffff",
    opacity: 0.05,
    rx: 5,
    stroke: "#00ffff",
    strokeWidth: 1
  })), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 190,
    textAnchor: "middle",
    fontSize: 10,
    fill: "#00ffff"
  }, "NumPy \u2022 OpenCV \u2022 PIL")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 200,
    y: 210,
    textAnchor: "middle",
    fontSize: 9,
    fill: "#00ffff",
    opacity: 0.8
  }, "100% Documented \u2022 pip-installable \u2022 10+ Utilities")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageProcessingUtils);
export default __webpack_public_path__ + "static/media/image_processing_utils.363966b09281b75f8499494e06d239dc.svg";
export { ForwardRef as ReactComponent };